import { Send } from 'domains/campaigns/types';

type GroupedSend = { parentIndex: number; parent: Send; children: Send[] };

const groupSendsByParentId = (sends: Send[]): GroupedSend[] => {
    const grouped: GroupedSend[] = [];

    sends.forEach((send, index) => {
        const directChildren: Send[] = [];
        sends.forEach((childSend, childIndex) => {
            if (
                send.id != null &&
                childSend.parentId != null &&
                childSend.parentId === send.id &&
                childIndex !== index
            ) {
                directChildren.push(childSend);
            }
        });
        grouped.push({ parentIndex: index, parent: send, children: directChildren });
    });

    return grouped;
};

export default groupSendsByParentId;
